import { defineMessages } from 'react-intl';

export default defineMessages({
  searchSymbolLibrary: {
    id: 'cboard.components.SymbolSearch.searchSymbolLibrary',
    defaultMessage: 'Search symbol library'
  },
  clearText: {
    id: 'cboard.components.SymbolSearch.clearText',
    defaultMessage: 'Clear text'
  },
  uploadAnImage: {
    id: 'cboard.components.InputImage.uploadImage',
    defaultMessage: 'Upload an image'
  },
  walkthroughEndTour: {
    id: 'cboard.components.SymbolSearch.walkthroughEndTour',
    defaultMessage: 'End Tour'
  },
  walkthroughCloseTour: {
    id: 'cboard.components.SymbolSearch.walkthroughCloseTour',
    defaultMessage: 'Close Tour'
  },
  walkthroughBack: {
    id: 'cboard.components.SymbolSearch.walkthroughBack',
    defaultMessage: 'Back'
  },
  walkthroughNext: {
    id: 'cboard.components.SymbolSearch.walkthroughNext',
    defaultMessage: 'Next'
  },
  walkthroughSymbolSearch: {
    id: 'cboard.components.SymbolSearch.walkthroughSymbolSearch',
    defaultMessage: 'Welcome to the symbol search!'
  },
  walkthroughSymbolSearchDesc: {
    id: 'cboard.components.SymbolSearch.walkthroughSymbolSearchDesc',
    defaultMessage:
      'The symbol search allows you to find symbols from various libraries to use for your board tiles.'
  },
  skinToneOptionsTitle: {
    id: 'cboard.components.SymbolSearch.skinToneOptionsTitle',
    defaultMessage: 'Skin tone'
  },
  skinToneOptionsDesc: {
    id: 'cboard.components.SymbolSearch.skinToneOptionsDesc',
    defaultMessage:
      'You can customize the skin tone symbols to better represent yourself and others. These options currently only apply to Cboard Symbols and ARASAAC symbols.'
  },
  hairColorOptionsTitle: {
    id: 'cboard.components.SymbolSearch.hairColorOptionsTitle',
    defaultMessage: 'Hair color'
  },
  hairColorOptionsDesc: {
    id: 'cboard.components.SymbolSearch.hairColorOptionsDesc',
    defaultMessage:
      'You can also customize the hair color of symbols. These options currently only apply to ARASAAC symbols.'
  },
  cboardSymbols: {
    id: 'cboard.components.SymbolSearch.cboardSymbols',
    defaultMessage: 'Cboard Symbols'
  },
  inclusivityOptions: {
    id: 'cboard.components.SymbolSearch.inclusivityOptions',
    defaultMessage: 'Inclusivity (ARASAAC & Cboard)'
  }
});
